// Mobilansicht für Handys: Erkennung, Umschalter und Startreiter.
//
// Reine Helfer ohne React, damit sie sich ohne DOM prüfen lassen
// (mobilModus.test.js). Der Hook dazu ist hooks/useMobilModus.js.

// Kürzere Bildschirmseite, bis zu der ein Touch-Gerät als Handy gilt. Handys
// liegen bei 360 bis 430 CSS-Pixeln, das kleinste iPad (mini) bei 744, ein
// Surface deutlich darüber. Gemessen wird die kürzere Seite, damit ein
// gedrehtes Handy ein Handy bleibt.
export const HANDY_MAX_KURZE_SEITE = 600;

// Bis v2.5.0 ließ sich die Mobilansicht je Gerät abschalten ("Desktop-
// Ansicht"). Wer das versehentlich tat, kam nicht mehr zurück, deshalb ist
// der Schalter seit v2.5.1 weg (Entscheidung A.Schindler, 2026-10-19). Der
// alte Eintrag wird nur noch aufgeräumt.
export const MOBIL_AUS_KEY = 'kcMobilansichtAus';

// Handy = grober Zeiger (Finger) UND kurze Seite höchstens 600 px. Die Breite
// allein reicht nicht (schmales Desktop-Fenster), der Zeiger allein auch
// nicht (Surface, Tablet).
export function istHandyGeraet({ grobZeiger, bildschirmBreite, bildschirmHoehe }) {
  if (!grobZeiger) return false;
  const breite = Number(bildschirmBreite) || 0;
  const hoehe = Number(bildschirmHoehe) || 0;
  const kurz = Math.min(breite || hoehe, hoehe || breite);
  return kurz > 0 && kurz <= HANDY_MAX_KURZE_SEITE;
}

export function erkenneHandy() {
  try {
    if (typeof window === 'undefined') return false;
    const grobZeiger = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    const scr = window.screen || {};
    return istHandyGeraet({ grobZeiger, bildschirmBreite: scr.width, bildschirmHoehe: scr.height });
  } catch (_) {
    // Ohne matchMedia/screen bleibt es bei der Desktop-Ansicht.
    return false;
  }
}

export function vergissAlteDesktopWahl() {
  try { window.localStorage.removeItem(MOBIL_AUS_KEY); } catch (_) {
    // Ohne localStorage gibt es auch nichts aufzuräumen.
  }
}

// Die drei Reiter der Mobilansicht, in Wischreihenfolge.
export const MOBIL_REITER = ['heute', 'meine', 'pool'];

// Den Pool sehen nur Manager (#44-Revision 2026-10-19), alle anderen
// bekommen nur "Heute" und "Meine".
export function sichtbareReiter(istManager) {
  return istManager ? MOBIL_REITER : MOBIL_REITER.filter(r => r !== 'pool');
}

// Beim Öffnen: heute geplante Tickets vor "Meine Tickets" vor Pool. Ohne
// Pool bleibt es bei "Meine".
export function startReiter({ heuteAnzahl, meineAnzahl, mitPool = true }) {
  if (heuteAnzahl > 0) return 'heute';
  if (meineAnzahl > 0 || !mitPool) return 'meine';
  return 'pool';
}

const TICKET_REF = /\[TICKET:([^\]]+)\]/;

// Zählt die heutigen Einträge, die an einem offenen Ticket des Benutzers
// hängen. Dieselbe Regel wie in der Liste "Heutige Termine"
// (CompactEventList): Ein Eintrag mit Ticket-Zuordnung zählt, wenn das
// Ticket nicht abgeschlossen und dem Benutzer zugewiesen ist. Ein Termin, der
// nur im Text auf ein Ticket verweist, zählt, solange dieses Ticket nicht als
// abgeschlossen bekannt ist. Reine Termine ohne Ticket zählen nicht.
export function zaehleHeuteGeplanteTickets({ events = [], plannedTicketEntries = [], statusMap = {}, benutzerEmail = '' }) {
  const ich = String(benutzerEmail || '').toLowerCase();
  if (!ich) return 0;
  const status = { ...(statusMap || {}) };
  (plannedTicketEntries || []).forEach((pe) => {
    if (pe && pe.id && pe.__ticketInfo) status[pe.id] = pe.__ticketInfo;
  });

  const abgeschlossen = new Set();
  Object.values(statusMap || {}).forEach((info) => {
    if (info && info.ticketNumber && info.status === 'abgeschlossen') abgeschlossen.add(String(info.ticketNumber));
  });

  let anzahl = 0;
  [...(events || []), ...(plannedTicketEntries || [])].forEach((eintrag) => {
    if (!eintrag) return;
    const info = status[eintrag.id];
    if (info) {
      if (info.status === 'abgeschlossen') return;
      if (String(info.assignedTo || '').toLowerCase() !== ich) return;
      anzahl += 1;
      return;
    }
    const treffer = eintrag.body && typeof eintrag.body.content === 'string' ? eintrag.body.content.match(TICKET_REF) : null;
    if (treffer && !abgeschlossen.has(String(treffer[1]))) anzahl += 1;
  });
  return anzahl;
}
